<template>
  <div class="left-box" >
    <ul >
      <li
        v-for="(item, index) of menuList"
        :key="index"
        @click="check(item.menuActive)"
        :class="[menuActive === item.menuActive ? 'active' : '']"
      >
        <p>
          <i v-if="item.menuActive === 5" class="styleIcons freeStyle"></i>
          <i
            :class="[
              menuActive === item.menuActive
                ? 'icons ' + item.className + 'Active'
                : 'icons ' + item.className + 'Default'
            ]"
          ></i>
        </p>
        <p>{{ item.name }}</p>
      </li>
      <div style="margin-top: 20px;text-align: center" v-html="adInfo"></div>
      <div style="position: fixed;bottom: 66px;left: 6px;" ><a href="https://account.5118.com/signin/protocol_so?bwl_noreplace=allow" target="_blank" class="disclaimer" data-v-4c7a656a="">免责声明</a></div>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
// import axios from "axios";
export default {
  data() {
    return {
      menuActive: 0,
      adInfo: "",
      menuList: [
        { name: "热点", menuActive: 1, className: "hot" },
        { name: "素材", menuActive: 2, className: "sc" },
        { name: "收藏", menuActive: 3, className: "bc" },
        { name: "文集", menuActive: 4, className: "wz" },
        { name: "样式", menuActive: 5, className: "styles" },
        // { name: "图片", menuActive: 6, className: "image" }
      ]
    };
  },
  computed: {
    ...mapState("sucaiSearch", {
      oldKeyWords: ["oldKeyWords"],
      oldTagWords: ["oldTagWords"],
      oldPic: ["oldPic"]
    }),
    leftShow: {
      get() {
        return this.$store.state.contents.leftShow;
      },
      set(val) {
        this.$store.state.contents.leftShow = val;
      }
    },
    hotShow: {
      get() {
        return this.$store.state.contents.hotShow;
      },
      set(val) {
        this.$store.state.contents.hotShow = val;
      }
    },
    scShow: {
      get() {
        return this.$store.state.contents.scShow;
      },
      set(val) {
        this.$store.state.contents.scShow = val;
      }
    }
  },
  created() {
    this.getAd();
  },
  watch: {
    $route(to) {
      if (to.fullPath.indexOf("material") !== -1) {
        this.menuActive = 2;
      }
      if (to.fullPath.indexOf("hot") !== -1) {
        this.menuActive = 1;
      }
      if (to.fullPath.indexOf("collect") !== -1) {
        this.menuActive = 3;
      }
      if (to.fullPath.indexOf("doc") !== -1) {
        this.menuActive = 4;
      }
      if (to.fullPath.indexOf("styles") !== -1) {
        this.menuActive = 5;
      }
      if (to.fullPath.indexOf("image") !== -1) {
        this.menuActive = 6;
      }
    }
  },
  mounted() {
    let to = this.$route.path;
    if (to === "/") {
      this.menuActive = 5;
      this.leftShow = true;
    }
    if (to.indexOf("hot") > 0) {
      this.menuActive = 1;
      this.leftShow = true;
    }
    if (to.indexOf("material") > 0) {
      this.menuActive = 2;
      this.leftShow = true;
    }
    if (to.indexOf("collect") > 0) {
      this.menuActive = 3;
      this.leftShow = true;
    }
    if (to.indexOf("doc") > 0) {
      this.menuActive = 4;
      this.leftShow = true;
    }
    if (to.indexOf("styles") > 0) {
      this.menuActive = 5;
      this.leftShow = true;
    }
    if (to.indexOf("image") > 0) {
      this.menuActive = 6;
      this.leftShow = true;
    }
  },
  methods: {
    ...mapActions("api", ["AGetAdInfo"]),
    async getAd() {
      let result = await this.AGetAdInfo();
      this.adInfo = result.data
        .replace('document.write("', "")
        .replace('");', "");
    },
    check(type) {
      this.menuActive = type;
      if (type === 1) {
        this.toHot();
      }
      if (type === 2) {
        this.toSc();
      }
      if (type === 3) {
        this.toCollect();
      }
      if (type === 4) {
        this.toWz();
      }
      if (type === 5) {
        this.toStyles();
      }
      if (type === 6) {
        this.toImage();
      }
    },
    toHot() {
      if (this.leftShow === false) {
        this.leftShow = true;
        this.$router.push("/hot");
      } else {
        if ("hotlist" === this.$route.name) {
          this.leftShow = false;
        } else {
          this.$router.push("/hot");
        }
      }
    },
    toSc() {
      if (this.leftShow === false) {
        this.leftShow = true;
        if (this.oldKeyWords !== "") {
          if (this.oldTagWords !== "") {
            this.$router.push(
              "/material/article/" + this.oldKeyWords + "/" + this.oldTagWords
            );
          } else {
            this.$router.push("/material/article/" + this.oldKeyWords);
          }
        } else {
          this.$router.push("/material");
        }
      } else {
        if ("material" === this.$route.name) {
          this.leftShow = false;
        } else {
          if (this.oldKeyWords !== "") {
            if (this.oldTagWords !== "") {
              this.$router.push(
                "/material/article/" + this.oldKeyWords + "/" + this.oldTagWords
              );
            } else {
              this.$router.push("/material/article/" + this.oldKeyWords);
            }
          } else {
            this.$router.push("/material");
          }
        }
      }
    },
    toCollect() {
      if (this.leftShow === false) {
        this.leftShow = true;
        this.$router.push("/collect");
      } else {
        if ("collect" === this.$route.name) {
          this.leftShow = false;
        } else {
          this.$router.push("/collect");
        }
      }
    },
    toWz() {
      if (this.leftShow === false) {
        this.leftShow = true;
        this.$router.push("/doc");
      } else {
        if ("doc" === this.$route.name) {
          this.leftShow = false;
        } else {
          this.$router.push("/doc");
        }
      }
    },
    toStyles() {
      if (this.leftShow === false) {
        this.leftShow = true;
        this.$router.push("/styles");
      } else {
        if ("styles" === this.$route.name) {
          this.leftShow = false;
        } else {
          this.$router.push("/styles");
        }
      }
    },
    toImage() {
      if (this.leftShow === false) {
        this.leftShow = true;
        if (this.oldPic !== "") {
          this.$router.push("/image/" + this.oldPic);
        } else {
          this.$router.push("/image");
        }
      } else {
        if ("image" === this.$route.name) {
          this.leftShow = false;
        } else {
          if (this.oldPic !== "") {
            this.$router.push("/image/" + this.oldPic);
          } else {
            this.$router.push("/image");
          }
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/config";
@import "../../assets/style/mixin";
.left-box {
  background-color: #ffffff;
  position: fixed;
  left: 0;
  top: 60px;
  width: 70px;
  // height: 100%;
  
  height: calc(100%-60);
  /*padding-top: 20px;*/
  border-right: 1px solid #dee3f8;
  .open_left {
    position: fixed;
    top: 40%;
    margin-left: 70px;
    cursor: pointer;
  }
  .icons {
    display: inline-block;
    height: 24px;
    width: 24px;
    vertical-align: text-bottom;
  }
  .styleIcons {
    display: inline-block;
    height: 18px;
    width: 32px;
    vertical-align: text-bottom;
    position: absolute;
    margin-left: 11px;
    margin-top: -11px;
  }
  .freeStyle {
    background: url("../../assets/image/styles/free_styles_ico.png") no-repeat
      50%;
  }
  .hotActive {
    background: url("../../assets/image/hot_active_ico.png") no-repeat 50%;
  }
  .hotDefault {
    background: url("../../assets/image/hot_default_ico.png") no-repeat 50%;
  }
  .scActive {
    background: url("../../assets/image/sc_active_ico.png") no-repeat 50%;
  }
  .scDefault {
    background: url("../../assets/image/sc_default_ico.png") no-repeat 50%;
  }
  .bcActive {
    background: url("../../assets/image/bc_active_ico.png") no-repeat 50%;
  }
  .bcDefault {
    background: url("../../assets/image/bc_default_ico.png") no-repeat 50%;
  }
  .wzActive {
    background: url("../../assets/image/wz_active_ico.png") no-repeat 50%;
  }
  .wzDefault {
    background: url("../../assets/image/wz_default_ico.png") no-repeat 50%;
  }
  .stylesActive {
    background: url("../../assets/image/styles_active_ico.png") no-repeat 50%;
  }
  .stylesDefault {
    background: url("../../assets/image/styles_default_ico.png") no-repeat 50%;
  }
  .imageActive {
    background: url("../../assets/image/image_active_ico.png") no-repeat 50%;
  }
  .imageDefault {
    background: url("../../assets/image/image_default_ico.png") no-repeat 50%;
  }
}
.active {
  background-color: #eff3ff;
  border-left: 3px solid #1257f7;
  p {
    color: #1257f7;
  }
}
li {
  font-size: 14px;
  padding: 15px 10px;
  text-align: center;
  cursor: pointer;
  &:hover {
    border-left: 3px solid #1257f7;
    p {
      color: #1257f7;
      .wzDefault {
        background: url("../../assets/image/wz_active_ico.png") no-repeat 50%;
      }
      .stylesDefault {
        background: url("../../assets/image/styles_active_ico.png") no-repeat
          50%;
      }
      .imageDefault {
        background: url("../../assets/image/image_active_ico.png") no-repeat 50%;
      }
      .bcDefault {
        background: url("../../assets/image/bc_active_ico.png") no-repeat 50%;
      }
      .hotDefault {
        background: url("../../assets/image/hot_active_ico.png") no-repeat 50%;
      }
      .scDefault {
        background: url("../../assets/image/sc_active_ico.png") no-repeat 50%;
      }
    }
  }
  p {
    color: #6a6a6a;
  }
}

.disclaimer {
      border: 1px solid #fe950e;
    border-radius: 3px;
    font-weight: 700;
    color: #fe950e;
    display: inline-block;
    font-size: 12px;
    line-height: 20px;
    background-color: #fef8e4;
    padding: 0 3px;
}
</style>
